module.exports = __webpack_public_path__ + "ff11eea8f68511ffaa5cfdcce3ccf5f7.png";


//////////////////
// WEBPACK FOOTER
// ./static/icons/WhatsApp_Logo.png
// module id = 3186
// module chunks = 0